import _ from 'lodash';
import { manageFilter } from '../Slick';

$(() => {
  bindColorSelector($('html'));
});

function onClickColorSelector(e) {
  e.preventDefault();
  const $alternative = $(this).attr('data-alternative');
  const $a = $('a.start-personalize');
  if ($a.length) {
    const href = _.template($a.data('href'));
    $a.attr('href', href({ alternative: $alternative }));
  }
  $(this)
    .addClass('selected').attr('aria-pressed', 'true')
    .siblings()
    .removeClass('selected').attr('aria-pressed', 'false');

  if ($('.slider--single').length > 0) {

    manageFilter($('.slider-for.model, .slider-nav.model'), $alternative);
  }
}

function bindColorSelector($scope) {
  $scope
    .find('.product-details .color-selector:not(.realLink)')
    .off('click')
    .on('click', onClickColorSelector);
  $scope.find('.product-details .color-selector.selected').trigger('click');
}

export { bindColorSelector };
